"use client";
import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import type React from "react";
import { TERMS_MODAL_STYLES } from "./termStyles";

interface TermsPreviewDialogProps {
	open: boolean;
	onClose: () => void;
	title: string;
	content: string;
	isLoading?: boolean;
}

export function TermsPreviewDialog({
	open,
	onClose,
	title,
	content,
	isLoading = false,
}: TermsPreviewDialogProps): React.ReactElement {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				{title}
				<IconButton onClick={onClose} size="small">
					<Close />
				</IconButton>
			</DialogTitle>
			<DialogContent sx={{ p: 3 }}>
				{isLoading ? (
					<Box sx={{ textAlign: "center", py: 4 }}>
						<Typography>読み込み中...</Typography>
					</Box>
				) : (
					<Box
						sx={{
							border: 1,
							borderColor: "divider",
							borderRadius: 1,
							p: 2,
							maxHeight: 600,
							overflowY: "auto",
						}}
					>
						<iframe
							srcDoc={`${TERMS_MODAL_STYLES}${content}`}
							sandbox="allow-popups allow-popups-to-escape-sandbox"
							title="利用規約プレビュー"
							width="100%"
							height="500px"
							style={{
								border: "none",
								borderRadius: "4px",
								backgroundColor: "#fafafa",
							}}
						/>
					</Box>
				)}
			</DialogContent>
		</Dialog>
	);
}
